import { Dialog, DialogActions, DialogDescription, DialogTitle } from '@oysterjs/ui/dialog';
import { Button } from '@oysterjs/ui/button';

/**
 * Confirmation dialog for archiving the current workspace. Mirrors the styling
 * used by the workspaces-list archive flow so the action looks identical
 * regardless of where it's invoked from.
 */
export const WorkspaceTopBarArchiveDialog = (props: {
  open: boolean;
  loading: boolean;
  error?: string;
  onCancel: () => void;
  onConfirm: () => void;
}) => (
  <Dialog open={props.open} onClose={props.onCancel} size="md">
    <DialogTitle>Archive workspace</DialogTitle>
    <DialogDescription>
      Are you sure you want to archive this workspace? This can't be undone.
    </DialogDescription>
    {props.error && <p className="mt-2 text-sm text-rose-600 dark:text-rose-400">{props.error}</p>}
    <DialogActions>
      <Button type="button" color="white" onClick={props.onCancel} disabled={props.loading}>
        Cancel
      </Button>
      <Button type="button" color="sky" onClick={props.onConfirm} loading={props.loading}>
        Archive
      </Button>
    </DialogActions>
  </Dialog>
);
